import { createIntl, createIntlCache } from "react-intl";
import { get } from "lodash";
import { getCookie } from "./cookies";
import { localeMessages } from "./internationalization";

const cache = createIntlCache();
const local = getCookie("locale") || "zh";

const localConvert: { [key in string]: string } = {
  zh: "zh-CN",
  en: "en-US",
};

const intl = createIntl(
  {
    locale: localConvert[local],
    messages: localeMessages[local],
  },
  cache
);

export const formatMessage = intl.formatMessage;

export const formatMessageForList = (list: object[], key: string) => {
  return list.map((item) => ({
    ...item,
    [key]: intl.formatMessage({ id: get(item, key) }),
  }));
};
